import React from 'react';

function NoPage() {
    return (
        <h1>this is the 404 page</h1>
    );
}

export default NoPage;